// src/data/changelog.js — release notes shown in the "What's New" panel.
// Newest entry first; bump `version` when you add one and every signed-in user
// sees the panel once. Keep entries student-facing (what they can DO), not
// technical. No emoji — house style.
export const CHANGELOG = [
  {
    version: '2026.07',
    date: 'July 2026',
    headline: 'A lot just landed',
    items: [
      { title: 'Polls in the feed and study groups',
        desc: 'Ask a question, get answers as live percentage bars. Single or multiple choice.',
        link: '/feed', cta: 'Try a poll' },
      { title: 'Study events with reminders',
        desc: 'Schedule a revision session in any group. Everyone who taps "I\'m going" gets a reminder before it starts.',
        link: '/groups', cta: 'Open groups' },
      { title: 'Revise your mistakes',
        desc: 'Every question you get wrong collects into a practice deck. Answer it right once and it leaves.',
        link: '/quiz', cta: 'Start revising' },
      { title: 'Streaks and leaderboards',
        desc: 'Practise daily to build a streak, and see the top students and longest streaks each week.',
        link: '/leaderboard', cta: 'See the board' },
      { title: 'Study buddies',
        desc: 'Find classmates taking the same courses as you, and message them in one tap.',
        link: '/study-buddies', cta: 'Find classmates' },
      { title: 'Saved items in one place',
        desc: 'Bookmark posts, flashcards, Q&A threads and course materials — they all land in Saved.',
        link: '/saved', cta: 'Open Saved' },
      { title: 'Class attendance',
        desc: 'See your attendance percentage for every course on your results page.',
        link: '/my-results', cta: 'View results' },
      { title: 'Flashcards that follow you',
        desc: 'Your review schedule and starred cards now sync across your phone and the website.',
        link: '/flashcards', cta: 'Open flashcards' },
    ],
  },
];

export const LATEST_VERSION = CHANGELOG[0]?.version || '';
